import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type CompanyFormValues = {
  name: string;
  address: string;
  phoneNumber: string;
  email: string;
  ninea: string;
};

export const companyValidationSchema = yup.object({
  name: yup.string().required('Le nom est obligatoire'),
  address: yup.string().required("L'adresse est obligatoire"),
  phoneNumber: yup
    .string()
    .required('Le numéro de téléphone est obligatoire')
    .matches(
      /^(77|78|75|76|70)\d{7}$/,
      'Format du numéro de téléphone invalide',
    ),
  email: yup
    .string()
    .email("L'email est invalide")
    .required("L'email est obligatoire"),
  ninea: yup.string().required('Le numéro de TVA est obligatoire'),
});

export const useCompanyForm = () => {
  const { handleSubmit, register, errors, reset } =
    useFormHandler<CompanyFormValues>(companyValidationSchema);

  return { handleSubmit, register, errors, reset };
};
